module.exports = __webpack_public_path__ + "img/rg-ur3.a5aa5886.jpg";